'use client';

import { useState, useEffect } from 'react';
import { Container } from '@/components/common/container';
import { BackendAuth } from '@/lib/auth-backend';

export function Footer() {
  const currentYear = new Date().getFullYear();
  const [version, setVersion] = useState(null);

  useEffect(() => {
    BackendAuth.apiCallJson('/api/nexus/production/releases/current')
      .then(data => {
        if (data?.current_release?.version) {
          setVersion(data.current_release.version);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <footer className="footer">
      <Container>
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
          <div className="flex order-2 md:order-1 gap-2 font-normal text-sm">
            <span className="text-muted-foreground">{currentYear} &copy;</span>
            <a
              href="https://xoffi.com"
              target="_blank"
              className="text-secondary-foreground hover:text-primary"
            >
              XOFFI
            </a>
            {version && (
              <span className="text-muted-foreground">v{version}</span>
            )}
          </div>
        </div>
      </Container>
    </footer>
  );
}
